// extracted by mini-css-extract-plugin
export default {"buttonImage":"LangButton_buttonImage__dXluK","menuList":"LangButton_menuList__XwJdw","menuItem":"LangButton_menuItem__yOwU+"};